import { render, staticRenderFns } from "./JobsTable.vue?vue&type=template&id=13411644&scoped=true"
import script from "./JobsTable.vue?vue&type=script&lang=js"
export * from "./JobsTable.vue?vue&type=script&lang=js"
import style0 from "./JobsTable.vue?vue&type=style&index=0&id=13411644&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13411644",
  null
  
)

export default component.exports